import styled from 'styled-components';

export const CloseButtonSt = styled.div.attrs(() => ({
  as: 'button',
  type: 'button',
  'aria-label': 'Close',
}))`
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
`;
